module.exports = __webpack_public_path__ + "static/media/warning-block.a6c9dfb2.svg";